import React from "react";
import "../styles/Consumerbanner.css";
import intake1 from "./assets/shilajit/intake1.png";
import intake2 from "./assets/shilajit/intake2.png";

const ShilajitPlusConsumeSection = () => {
  const steps = [
    {
      title: "Step 1",
      text: "Take 1/2 teaspoon of pure SHILAJIT+ resin or 1-2 capsules",
      image: intake1,
    },
    {
      title: "Step 2",
      text: "Mix with warm milk or water, stir well and consume once daily - preferably in the morning before breakfast",
      image: intake2,
    },
  ];

  return (
    <section className="consume-banner">
      <h2 className="consume-heading">
        सेवन करने का तरीका (How To Consume)
      </h2>

      <div className="consume-images">
        {steps.map((step, index) => (
          <div className="consume-card" key={index}>
            <img 
              src={step.image}
              alt={step.title}
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '10px',
                objectFit: 'contain',
                marginBottom: '15px'
              }}
            />
            <h4>{step.title}</h4>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShilajitPlusConsumeSection;
